import React from 'react';
import { Card, Text, Group, Badge, Stack, Divider, Box } from '@mantine/core';
import { IconCalendar, IconUser, IconInfoCircle, IconClock, IconChecklist } from '@tabler/icons-react';

interface ResourceProps {
  resourceType: 'Goal' | 'Task';
  resourceData: any[];
}

const ResourceDisplay: React.FC<ResourceProps> = ({ resourceType, resourceData }) => {
  return (
    <Stack spacing="lg">
      {resourceData.map((resource, index) => (
        <Card key={index} shadow="md" padding="lg" radius="md" withBorder>
          <Group position="apart" mb="md">
            <Text size="lg" weight={600} color="dark">
              {resourceType === 'Goal' ? 'Goal Details' : 'Task Details'}
            </Text>
            <IconChecklist size={20} />
          </Group>

          <Divider my="sm" />

          {resourceType === 'Goal' && (
            <Box>
              <Group
                mb="xs"
                spacing="xs"
                align="flex-start"
                noWrap
                sx={{ flexWrap: 'wrap' }}
              >
                <IconInfoCircle size={18} style={{ marginTop: '4px' }} />
                <Text
                  size="sm"
                  sx={{
                    wordWrap: 'break-word',
                    whiteSpace: 'pre-wrap',
                    flex: 1,
                    overflowWrap: 'break-word',
                  }}
                >
                  <strong>Description:</strong>{' '}
                  {resource.description?.coding[0]?.display || 'N/A'}
                </Text>
              </Group>

              <Group mb="xs">
                <IconChecklist size={18} />
                <Text size="sm">
                  <strong>Status:</strong>{' '}
                  <Badge color="green">{resource.lifecycleStatus}</Badge>
                </Text>
              </Group>

              <Group mb="xs">
                <IconCalendar size={18} />
                <Text size="sm">
                  <strong>Start Date:</strong> {resource.startDate || 'N/A'}
                </Text>
              </Group>

              <Group mb="xs">
                <IconClock size={18} />
                <Text size="sm">
                  <strong>Last Updated:</strong>{' '}
                  {new Date(resource.meta?.lastUpdated).toLocaleString() || 'N/A'}
                </Text>
              </Group>
            </Box>
          )}

          {resourceType === 'Task' && (
            <Box>
              <Group
                mb="xs"
                spacing="xs"
                align="flex-start"
                noWrap
                sx={{ flexWrap: 'wrap' }}
              >
                <IconInfoCircle size={18} style={{ marginTop: '4px' }} />
                <Text
                  size="sm"
                  sx={{
                    wordWrap: 'break-word',
                    whiteSpace: 'pre-wrap',
                    flex: 1,
                    overflowWrap: 'break-word',
                  }}
                >
                  <strong>Description:</strong>{' '}
                  {resource.description || 'N/A'}
                </Text>
              </Group>

              <Group mb="xs">
                <IconChecklist size={18} />
                <Text size="sm">
                  <strong>Status:</strong>{' '}
                  <Badge color="green">{resource.status}</Badge>
                </Text>
              </Group>

              <Group mb="xs">
                <IconClock size={18} />
                <Text size="sm">
                  <strong>Last Updated:</strong>{' '}
                  {new Date(resource.meta?.lastUpdated).toLocaleString() || 'N/A'}
                </Text>
              </Group>
            </Box>
          )}
        </Card>
      ))}
    </Stack>
  );
};

export default ResourceDisplay;
